import { createSlice } from "@reduxjs/toolkit";
import { format, startOfWeek, endOfWeek } from "date-fns";

const today = new Date();
const startDate = format(today, "yyyy-MM-dd");

export const dateRange = createSlice({
  name: "dateRange",
  initialState: {
    dateRangeType: "daily",
    customDateRange: {
      from: startDate,
      to: startDate,
    },
  },
  reducers: {
    updateDateRangeType: (state, action) => {
      state.dateRangeType = action.payload;
    },
    updateCustomDateRange: (state, action) => {
      state.customDateRange = action.payload;
    },
    setWeekRange: (state, action) => {
      const weekStart = startOfWeek(new Date(action.payload));
      const weekEnd = endOfWeek(new Date(action.payload));
      state.customDateRange = {
        from: format(weekStart, "yyyy-MM-dd"),
        to: format(weekEnd, "yyyy-MM-dd"),
      };
      state.dateRangeType = "weekly";
    },
    setMonthRange: (state, action) => {
      const date = new Date(action.payload);
      const monthStart = new Date(date.getFullYear(), date.getMonth(), 1);
      const monthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      state.customDateRange = {
        from: format(monthStart, "yyyy-MM-dd"),
        to: format(monthEnd, "yyyy-MM-dd"),
      };
      state.dateRangeType = "monthly";
    },
  },
});

export const {
  updateDateRangeType,
  updateCustomDateRange,
  setWeekRange,
  setMonthRange,
} = dateRange.actions;

export default dateRange.reducer;
